import React from 'react';
import { useLocation } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import DigibesDeviceListPage from '@modules/restaurant/Devices/tabs/digibes';
import routes from '@routes';

const DigibesDeviceDetailPage = () => {
    const translate = useTranslate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const restaurantId = queryParams.get('restaurantId');
    const restaurantName = queryParams.get('restaurantName');
    const collapseId = queryParams.get('collapseId');
    const tabKey = queryParams.get('tab') || 'ordercon';

    return (
        <PageWrapper
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.ordercon),
                    path: collapseId 
                        ? `${routes.listOrderconDevicePage.path}?collapseId=${collapseId}` 
                        : routes.listOrderconDevicePage.path,
                },
                { 
                    breadcrumbName: restaurantName, 
                },
            ]}
        >
            <DigibesDeviceListPage
                tabKey={tabKey}
                restaurantId={restaurantId}
                savedFilter={null}
                onFilterChange={() => {}}
            />
        </PageWrapper>
    );
};

export default DigibesDeviceDetailPage;